import {Container} from "@mui/material"

import {LoadingCard} from "@/components/LoadingCard.tsx";

export function LoadingPage() {
  return (
    <Container
      sx={{
        height: "80vh",
        bgcolor: "background.default",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <LoadingCard/>
    </Container>
  )
}
